<template>
	<div>
		<div v-if="parentsData.length*1 > 0">
			<!-- //直播课 -->
			<div class="course-box"  v-if="isLive == 'live'">
				<a target="_blank" class="flex-start course-card cursor" :class="{'card-padding':isStatus == 1}"
				@click="navTo('/details',name,item)"
				 v-for="(item,index) in parentsData" :key="index">
					<span class="status" v-if="isStatus == 1">{{item.live_state | isBegin}}</span>
					<!-- <img :src="item.avatar" alt=""> -->
					<img :src="item.main_drawing_pc[0]" alt="">
					<div class="course-content" style="width: 390px;">
						<div class="course-name fb fsm2 line1">{{item.title}}</div>
						<div class="course-pro fsm2">
							<div class="course-teacher line1 fsmain">
								<span class="name">{{item.lecturer.name}}</span> {{item.lecturer.brief_intro}}
							</div>
							<div class="course-time fsmain">
								直播时间：{{item.live_time}}
							</div>
							<div class="course-join flex-space">
								<span v-if="isLeft == 1">已有{{item.take_part_num}}人参与拼团</span>
								<span style="font-size: 14px;" v-else-if="isLeft == 2">{{item.viewers}}人看过</span>
								<span v-else>已有{{item.appointment_count}}人已预约</span>
								<span class="link" v-if="isLeft == 1 ">去拼团</span>
								<div v-else>
									<div v-if="isLeft == 2">
										<span class="price fsm2" v-if="item.viewing_restrictions == 'free' || item.viewing_restrictions == 'appoint'">免费</span>
										<span class="price fsm2" v-else-if="item.viewing_restrictions == 'pay'"><span class="fsm-2">￥</span>{{item_.price || 0}}</span>
										<span class="price fsm2" v-else-if="item.viewing_restrictions == 'encryption'">加密</span>
									</div>
									<span class="link" v-else>{{item.live_state | isBegin_}}</span>
								</div>
							</div>
						</div>
					</div>
				</a>
			</div>
			<div v-else>
				<div class="course-box" v-if="parentsData.length > 0">
					<router-link tag="div" class="course-video cursor"
					:to="{path:'/details?id='+item_.id+'&name='+name}"
					v-for="(item_,index_) in parentsData" :key="index_">
						<img :src="item_.main_drawing_pc[0]" alt="">
						<div class="course-content">
							<div class="course-name line2 fb fsm2">{{item_.title}}</div>
							<div class="course-pro fsm2">
								<div class="course-teacher line1 fsmain">
									<span class="name">{{item_.lecturer.name}}</span> {{item_.lecturer.brief_intro}}
								</div>
								<div class="course-join flex-space fsm-2" v-if="isLeft == 1">
									已有{{item_.take_part_num}}人参与拼团
									<span class="link fsm2">去拼团</span>
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
		<div class="mt-noData" v-else>
			<noData></noData>
		</div>
	</div>

</template>

<script>
	import noData from '@/components/noData/index.vue'
	export default{
		props: {
			isStatus: {
				type: Number, // 是否显示未开始 1显示  0不显示
				defult: 0// 默认不显示
			},
			parentsData: {
				type: Array,
				default: () => { return [] }
			},
			isLeft: {
				type: Number,
				default: 0
			},
			isLive: {
				type: String,
				default: 'live'
			},
			name: {
				type: String,
				default: ''
			}
		},
		components: {
			noData
		},
		filters: {
			isBegin(item) {
				if (item == 'not_started') {
					return '未开始'
				} else if (item == 'in_progress') {
					return '直播中'
				} else {
					return '看回放'
				}
			},
			isBegin_(item) {
				if (item == 'not_started') {
					return '去预约'
				} else if (item == 'in_progress') {
					return '去观看'
				} else {
					return '看回放'
				}
			}
		},
		data() {
			return {

			}
		},
		methods:{
			navTo(url,name,item){
				if(item.group_buy_price){
					if(item.hasOwnProperty('video_list')){
						this.$router.push('/details?id='+item.id+'&propType=ptVideo'+'&title='+this.name)
					}else if(item.live_state){
						this.$router.push('/details?id='+item.id+'&propType=ptLive'+'&title='+this.name)
					}
				}else{
					if(item.hasOwnProperty('video_list')){
						this.$router.push('/details?id='+item.id+'&propType=video'+'&title='+this.name)
					}else{
						this.$router.push('/details?id='+item.id+'&propType=live'+'&title='+this.name)
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.course-box{
		display: flex;
		flex-wrap: wrap;
		.course-card{
			background: #FFFFFF;
			box-shadow: 0 0 12px rgba(187,178,178,0.25);
			border-radius: 8px;
			padding: 20px;
			width: 590px;
			margin-bottom: 20px;
			position: relative;
			&:nth-of-type(2n){
				margin-left: 20px;
			}
			.status{
				width: 80px;
				height: 30px;
				background: #E5E5E5;
				border-radius: 8px 15px 15px 0px;
				position: absolute;
				top: 0;
				left: 0;
				text-align: center;
				line-height: 30px;
				color: #999999;
			}
			img{
				width: 140px;
				height: 180px;
				border-radius: 5px;
				margin-right: 20px;
			}
			.course-name{
				margin-bottom: 5px;
				height: 52px;
			}
			.course-pro{
				color: #666;
				.course-teacher{
					margin-bottom: 10px;
					.name{
						position: relative;
						margin-right: 16px;
						&:after{
							content: '';
							display: block;
							position: absolute;
							top: 3px;
							width: 1px;
							height: 18px;
							background-color: #999;
							right: -12px;
						}
					}
				}
				.course-time{
					margin-bottom: 10px;
				}
				.course-join{
					position: absolute;
					bottom: 30px;
					width: 390px;
					.price{
						color: #F26F2A;
						font-weight: bold;
					}
					.link{
						width: 90px;
						height: 34px;
						background: linear-gradient(87deg, #FD9A3D, #F3702A);
						border-radius: 17px;
						text-align: center;
						line-height: 34px;
						color: #fff;
					}
				}
			}
		}
		.card-padding{
			padding: 50px 20px 20px;
		}
	}
	.course-video{
		background: #FFFFFF;
		box-shadow: 0 0 12px rgba(187,178,178,0.25);
		border-radius: 8px;
		width: 290px;
		margin-bottom: 20px;
		position: relative;
		margin-right: 13px;
		overflow: hidden;
		&:nth-of-type(4n){
			margin-right: 0;
		}
		.status{
			width: 80px;
			height: 30px;
			background: #E5E5E5;
			border-radius: 8px 15px 15px 0px;
			position: absolute;
			top: 0;
			left: 0;
			text-align: center;
			line-height: 30px;
			color: #999999;
		}
		img{
			width: 290px;
			height: 180px;
		}
		.course-content{
			padding: 10px 10px 15px;
			.course-name{
				margin-bottom: 5px;
				height: 52px;
			}
			.course-pro{
				color: #666;
				.course-teacher{
					margin-bottom: 16px;
					.name{
						position: relative;
						margin-right: 16px;
						&:after{
							content: '';
							display: block;
							position: absolute;
							top: 3px;
							width: 1px;
							height: 18px;
							background-color: #999;
							right: -12px;
						}
					}
				}
				.course-join{
					.price{
						color: #F26F2A;
						font-weight: bold;
					}
					.link{
						width: 90px;
						height: 34px;
						background: linear-gradient(87deg, #FD9A3D, #F3702A);
						border-radius: 17px;
						text-align: center;
						line-height: 34px;
						color: #fff;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Course/live.vue